import { StageMapping } from "@forwardflow/components/Campaign/StageMapping";

const StageMappingPage = () => {
  return (
    <>
      <StageMapping />
    </>
  );
};

export default StageMappingPage;
